_getVideoDataThunk